module.exports = __webpack_public_path__ + "img/cms_intro.553eefc4.png";